import { FormHelperText, TextField, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { ChangeEvent, FC } from 'react';
import { useDictionary, useIsDesktop } from 'Hooks';
import { illegalChars } from 'Regex';
export interface INoteTextField {
  value: string;
  onChange: (value: string) => void;
  error: boolean;
  title?: string;
}

const MAX_LENGTH = 500;

export const NoteTextField: FC<INoteTextField> = ({
  value,
  onChange,
  error,
  title,
}) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.UniversalRequest);
  const isDesktop = useIsDesktop();

  return (
    <>
      <Typography variant={'body1'} component='label' htmlFor='request-note'>
        {title || dictionary.uploadFile.note}
      </Typography>
      <TextField
        id='request-note'
        aria-describedby={error ? 'request-note-error' : undefined}
        multiline
        rows={4}
        variant='outlined'
        placeholder={dictionary.uploadFile.notePlaceholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onInput={(e: ChangeEvent<HTMLInputElement>) => {
          let newValue: string = e.target.value
            .replace(illegalChars, '')
            .replace(/\r\n/g, ' ');
          const extraCharsLength = JSON.stringify(newValue).length - 502;
          newValue = newValue.slice(0, 500 - extraCharsLength);
          e.target.value = newValue;
        }}
        inputProps={{
          maxLength: MAX_LENGTH,
        }}
        error={error}
        helperText={`${JSON.stringify(value).length - 2}/${MAX_LENGTH}`}
        fullWidth
        margin='normal'
        required
        InputProps={{
          style: {
            background: '#fff',
            border: error ? '1px solid #ec0000' : '1px solid #B7CCFF',
            borderRadius: '8px',
          },
        }}
        FormHelperTextProps={{
          style: {
            color: error ? '#ec0000' : '#A020FF',
            textAlign: 'left',
            fontWeight: value.length === MAX_LENGTH ? 'bold' : undefined,
          },
        }}
        sx={{
          '& .MuiInputBase-input': {
            zIndex: 9,
          },
          '& .MuiFormHelperText-root': {
            position: 'relative',
            top: isDesktop ? '-40px' : '-30px',
            fontSize: isDesktop ? '18px' : '14px',
            zIndex: 0,
          },
          '.MuiOutlinedInput-notchedOutline': { border: 'none' },
        }}
      />
      {error && (
        <FormHelperText
          role='alert'
          error={error}
          id={'request-note-error'}
          sx={{ m: '-38px 0 18px', fontSize: '14px' }}
        >
          {dictionary.uploadFile.noteErrorMsg}
        </FormHelperText>
      )}
    </>
  );
};
